import { computed } from 'vue';
import { useRoute } from 'vue-router';

// Keep this explicit: any follow-up viewer surface that needs viewer-only UI
// must add its route name here instead of relying on broad viewer* matching.
const VIEWER_ROUTE_NAMES = new Set(['viewer', 'viewerMain']);

export const useIsViewerPage = () => {
  const route = useRoute();

  return computed(() => (route.matched ?? []).some(matchedRoute => typeof matchedRoute.name === 'string' && VIEWER_ROUTE_NAMES.has(matchedRoute.name)));
};
